import { RepositoryFactory } from "@/Apicall/masters/RepositoryFactory";
const extensions = RepositoryFactory.get("extensions");
export default {
  getExtensions({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await extensions.getExtensions(payload);
        commit("GET_EXTENSIONS", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  createExtensionOrder({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await extensions.createExtensionOrder(payload);
        commit("CREATE_EXTENSIONS_ORDER", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  mailTriggred({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await extensions.mailTriggred(payload);

        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  addExtensionRequest({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await extensions.addExtensionRequest(payload);
        commit("ADD_EXTENSIONS_REQUEST", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
  getExtensionRequest({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await extensions.getExtensionRequest(payload);
        commit("GET_EXTENSIONS_REQUEST", data.data);
        resolve(data);
      } catch (error) {
        console.log(error);
        reject(error);
      }
    });
  },
};
